import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { totalBonuses, totalVolumes } from '../data/offer';
export function GuaranteeSection() {
  return <section className="bg-blue-900 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-98" data-mp="9ttgc9z21wy4">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-99" data-mp="et67v80vfs71">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-slate-300/40 bg-blue-950/70 p-8 sm:p-12" data-id="element-100" data-mp="euqwyi4f2ixi">
          <span className="metal-silver inline-flex rounded-full p-4 text-blue-950" data-id="element-101" data-mp="smxd447kkpwy">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-102" data-mp="xj5or7mk60zd" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-white" data-id="element-103" data-mp="12kldb9ny2pmi">
            Complete 7-day guarantee
          </h2>
          <p className="mt-4 leading-relaxed text-slate-300" data-id="element-104" data-mp="25rxb0sta741m">
            Open all {totalVolumes} volumes. Review all {totalBonuses} bonuses. Use them in your most challenging
            nuclear energy class this week. If you feel your students didn't respond better or the materials didn't
            save you hours of work:
          </p>
          <p className="mt-6 rounded-lg border border-slate-300/30 bg-blue-900 px-5 py-4 text-lg font-extrabold text-white" data-id="element-105" data-mp="1rt79n0zfii7g">
            We refund 100% of your money. No questions. No forms. No complications.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-slate-300" data-id="element-106" data-mp="2jk3p89cvj0yf">
            Because if this teacher ready doesn't deliver the value we promise, we don't want to keep your money.
          </p>
        </motion.div>
      </div>
    </section>;
}